import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getDealerKvps } from 'src/bff/api/get-dealer-kvps';
import { useGetKvps } from 'src/feature-app';

export function useGetDealer(kvps?: string) {
	const dispatch = useDispatch();
	const [dealerName, setDealerName] = useState(null);
	const [selectedDealer, setSelectedDealer] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const { kvps: selectedKvps, isMyCurrentDealer } = useGetKvps(kvps);

	const requestDealer = async () => {
		if (!selectedKvps) {
			setLoading(false);
			setError(true);
			console.error('KVPS not found');
		}
		const dealer = await getDealerKvps(selectedKvps);

		if (dealer) {
			setDealerName(dealer.name);
			setSelectedDealer(dealer);

			if (isMyCurrentDealer) {
				dispatch({ type: 'SET_MY_CURRENT_DEALER', payload: dealer });
			} else {
				dispatch({ type: 'SET_SELECTED_DEALER', payload: dealer });
				dispatch({ type: 'SET_URL_DEALER', payload: dealer });
				dispatch({ type: 'UPDATE_SUGGESTION', payload: dealer });
			}

			const { longitude, latitude } = dealer.markerInfo.svcLocation;
			const point = {
				type: 'Feature',
				properties: {
					cluster: false,
					concesionId: dealer.id,
					dealer: dealer,
				},
				geometry: {
					type: 'Point',
					coordinates: [longitude, latitude],
				},
			};
			const points = [point];
			dispatch({ type: 'SET_DEALERS', payload: [dealer] });
			dispatch({ type: 'SET_POINTS', payload: points });
			dispatch({
				type: 'DEALERS_OR_INSTALLATIONS_MODE',
				payload: 'dealers',
			});
		} else {
			setDealerName(null);
			setSelectedDealer(null);
			setError(true);
			console.error('Dealer not found');
		}
		setLoading(false);
	};

	useEffect(() => {
		requestDealer();
	}, []);

	return { dealerName, selectedDealer, loading, error };
}
